import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import Dialogue from "common/components/modules/chat/dialogue";
import PageHeader from 'common/components/modules/page-header';
// import ChatUserAvatar from 'common/components/modules/chat/chat-user-avatar';
// import TipNotificationMessage from 'common/components/modules/chat/tip-notification';
import ChatItem from './chat-item';
import Button from 'common/components/elements/buttons/primary';
import CircleLoader from 'common/components/elements/loader/circle';
import Icon from 'common/components/elements/icons';
import ConversationNotActive from './not-active';
import cx from 'classnames';
import SwitchItem from 'common/components/modules/multiply-switch/item-v2';
import { uploadImageApi } from 'sites/api/MixApi';
import { getObjectUrl } from 'sites/api/GuestApi';
import { useSelector } from 'react-redux';
import { siteInfoSelector } from 'sites/state/modules/common/selectors';


const DesktopChat = ({
   onCloseChat,
   hasAccess,
   converstions,
   onClickConversation,
   onScroll,
   fetchNextMessages,
   isFetchingMessage,
   authUser,
   likesInfo = {
      data: [],
      fetching: false,
      fetchingByScroll: false,

   },
   onLikedMemberPagination,
   onFetchLikesInfo,
   onClickLockedButton,
   planPrice,
   onUserTyping,
   typerText,
   onLikeMessage,

   data,
   activeMessageTab,
   onDeleteMessag,
   onSendMessage,
   mutedInfo,
   emptyState,
   onReadMessage,
   isMobile,
   lastSeen,
   setMutedMemberInfo,
   isNotActive,
   notActiveText,
   onClickNotActive,
   isSocketConnected,
   loaderText,
   nonAccessAvatar,
   onClickTip,

   isOpen,
   closeChatPopup,
   // onlineStream,
   onStream,
   goToContentMessage,
   needToJoin,
   goToJoin,
   purchaseMessageId,
   paymentButtonLoading,
   streamConversation,
   openLiveStreamConversation,
   userStatus,
   adminScreenName,
   isNewVersion,
   showOnlyViews,
   isLiveStream,
   downloadFile,
   adminUuid,
   onSendVoiceMessage,
   privateAttachmentSettings,
   paymentButtonResourceId,
   onUpdateRecordStatus,
   onSaveUploadPhotos,
   goTo,
   mainMessageId,
   screenWidth,
   onClickNotificationMessageButton,
   currentLiveStream,
   initLivestreamData,
}) => {

   const activeConverstionId  = activeMessageTab.id
   const content = converstions.find(e => e.chat_room_id === activeConverstionId)?.content;
   const siteInfo = useSelector(siteInfoSelector)

   const uploadImage = async (appendData) => {
      try {
         const { data: { path } } =  await uploadImageApi(appendData);
         const fullSrc = await getObjectUrl([path], 'images/thumb-');
         return Promise.resolve({ fullSrc, path });
      } catch (error) {
         return Promise.reject(error);
      }
   }

   return (

      <div className='h-full w-full flex flex-col member-chat-list min-h-full border border-divider dark:border-divider-dark bg-panel dark:bg-panel-dark' >
         {
            !showOnlyViews && (
               <PageHeader
                  leftIconName='close'
                  title='Chat'
                  fontIconSize='doubleLarge'
                  leftIconAction={ () => onCloseChat(true) }
                  tipAction={ isLiveStream ? null : authUser ? () => onClickTip(true) : null }
                  user={ {} }
                  isHelpIcon={ !isLiveStream }
               />
            )
         }
         <div
            style={ {
               paddingTop: showOnlyViews ? '0' : '58px',
               // background: 'rgba(255, 255, 255, 0.6)',
            } }
            className={ `flex flex-1 flex-col items-center overflow-y-hidden relative  bg-panel max-w-ful dark:bg-panel-dark` }>
            {
               !hasAccess && (
                  <>
                     <div className='absolute top-0 left-0 w-full z-30 overflow-y-hidden chat-have-not-access flex'
                        style={ {
                           marginTop: showOnlyViews ? '0px' : !authUser ? '58px' : '131px',
                           height: showOnlyViews ? '100%' : !authUser ? 'calc(100% - 58px)' : 'calc(100% - 131px)',
                        } }
                     >
                        {
                           'active' !== userStatus && (
                              <>
                                 <div
                                    className='px-4 flex items-center h-full justify-center flex-col bg-transparent absolute top-0 left-0 z-30 w-full non-content-h'>
                                    {
                                       nonAccessAvatar && (
                                          <img src={ nonAccessAvatar } alt='' className='w-28 h-28 rounded-full object-cover object-center' />
                                       )
                                    }
                                    {
                                       !!planPrice && (
                                          <>
                                             <span className='text-major font-bold text-xl mb-3 mt-7 dark:text-major-dark'>Wanna chat?</span>
                                             <span className='text-major leading-tight text-center dark:text-major-dark'>Join to start sending and receiving  messages.</span>

                                             <div className='h-11 mt-7'>
                                                <Button
                                                   text='Get membership to chat'
                                                   borderRadius='large'
                                                   onClick={  () => {
                                                      closeChatPopup()
                                                      onClickLockedButton(false, false)
                                                   }  }
                                                   fontWeight='medium'
                                                   textSize='base'
                                                   primaryColor
                                                   classNames='h-full pl-[18px] pr-[10px]'
                                                   iconName='membership'
                                                   iconPosition='left'
                                                   fontIconSize='extraLarge'
                                                />
                                             </div>
                                          </>
                                       )
                                    }
                                    {
                                       !authUser && (
                                          <>
                                             <span className='mt-10 leading-tight text-major dark:text-major-dark'>Already a member?</span>
                                             <div className='mt-3 w-48'>
                                                <Button
                                                   text='Sign in'
                                                   primaryColor
                                                   backgroundColor='transparent'
                                                   classNames='skin-primary-border border'
                                                   borderRadius='large'
                                                   onClick={ () => onClickLockedButton(true) }
                                                />
                                             </div>
                                          </>
                                       )
                                    }
                                 </div>
                              </>
                           )
                        }

                        {
                           'active' === userStatus && (
                              <div
                                 className='flex flex-col bg-panel dark:bg-panel-dark rounded-lg border-2 border-divider dark:border-divider-dark m-auto p-4 active-members-noraccess'
                              >
                                 <div className='flex items-center mb-4'>
                                    <div className='h-6 w-6 flex items-center justify-items-center mr-1'>
                                       <Icon
                                          size='xl'
                                          name='details'
                                          style={ {
                                             color: '#FFC37D',
                                          } }
                                       />
                                    </div>

                                    <span className='text-major dark:text-major-dark font-bold leading-tight'>Important notice</span>
                                 </div>
                                 <span className='text-sm text-secondary dark:text-secondary-dark leading-4'>
                                    {adminScreenName} has restricted your access to chat.
                                 </span>
                              </div>
                           )
                        }
                     </div>
                  </>
               )
            }
            {
               !isNewVersion && converstions && converstions.length > 0 && (
                  <div
                     className={ cx({
                        'flex w-full max-w-full bg-panel dark:bg-panel-dark': true,
                        'border-b border-divider dark:border-divider-dark': converstions.length === 1,
                        // 'notranslate': !siteInfo?.chat_settings?.chat_auto_translator,
                     }) }
                  >
                     {
                        [...converstions].reverse().map((converstion, index) => {
                           return (
                              <ChatItem
                                 key={ converstion.chat_room_id || index.toString() }
                                 name={ converstion.conversation_name || converstion.username }
                                 isGroupChat={ !converstion.username }
                                 unreadMessageCount={ converstion.unread_messages_count }
                                 active={ converstion.chat_room_id === activeConverstionId }
                                 onClick={ () => {
                                    if(converstion.chat_room_id === 'live_stream') {
                                       openLiveStreamConversation()
                                    } else {
                                       if(!!converstion.user_uuid) {
                                          onReadMessage(converstion)
                                       }
                                       if(converstion.chat_room_id !== activeConverstionId){
                                          onClickConversation(converstion.chat_room_id, converstion)
                                       }
                                    }
                                 } }
                                 avatars={ converstion.user_avatar || converstion.avatars }
                                 userIsTyping={ converstion.user_is_typing }
                                 unreadMessagesCount={ converstion.unread_messages_count }
                                 isOnline={ converstion.is_online }
                                 index={ index }
                                 withoutAvatar={ converstion.chat_room_id === 'live_stream' }
                              />
                           )
                        })
                     }
                  </div>
               )
            }
            {
               isNewVersion && (
                  <div
                     style={ {
                        minHeight: '75px',
                     } }
                     className='max-w-full flex overflow-x-auto mx-auto w-auto'>
                     <div
                        style={ {
                           background: window.site_dark_bg ? '#252525' : '#FAFBFC',
                           border: window.site_dark_bg ? '1px solid #434343' : '1px solid #F2F4F7',
                           padding: '6px',
                        } }
                        className='flex items-center justify-center rounded-lg mt-4'>
                        {
                           converstions.map((converstion, index) => {
                              return (
                                 <SwitchItem
                                    key={ converstion.chat_room_id || index.toString() }
                                    checked={ converstion.chat_room_id === activeConverstionId }
                                    onClick={ () => {
                                       if(converstion.chat_room_id === 'live_stream') {
                                          openLiveStreamConversation()
                                       } else {
                                          if(!!converstion.user_uuid) {
                                             onReadMessage(converstion)
                                          }
                                          if(converstion.chat_room_id !== activeConverstionId){
                                             onClickConversation(converstion.chat_room_id, converstion)
                                          }
                                       }
                                    } }
                                    label={ converstion.conversation_name || converstion.username }
                                    className='whitespace-nowrap'
                                 >
                                    {
                                       converstion.unread_messages_count && (
                                          <div className='chat-left-new-count bg-error dark:bg-error-dark rounded-full flex items-center justify-center ml-2'>
                                             <span className='text-major-dark text-xs font-medium'> { converstion.unread_messages_count > 100 ? '99+' : converstion.unread_messages_count} </span>
                                          </div>
                                       )
                                    }
                                 </SwitchItem>

                              )
                           })
                        }
                     </div>

                  </div>
               )
            }
            {
               isNotActive && notActiveText && (
                  <ConversationNotActive
                     text={ notActiveText }
                     onClick={ onClickNotActive }
                  />
               )
            }
            {
               !!authUser && !(isNotActive && notActiveText) && (
                  <>
                     {
                        isFetchingMessage && (
                           <div className='flex flex-col items-center justify-center overflow-y-hidden flex-1 w-full h-auto'>
                              <CircleLoader color='primary' />
                              {
                                 loaderText && (
                                    <span className='text-placeholder dark:text-placeholder-dark leading-tight mt-5'>{loaderText}</span>
                                 )
                              }
                           </div>
                        )
                     }
                     {
                        streamConversation && (streamConversation)
                     }
                     {
                        !streamConversation && !isFetchingMessage && data && (
                           <Dialogue
                              messages={ data.data }
                              isEmpty={ data.isEmpty }
                              unlock={ hasAccess }
                              onScroll={ onScroll }
                              isNewFetching={ fetchNextMessages }
                              authUser={ authUser }
                              isAdmin={ false }
                              onFetchLikesInfo={ onFetchLikesInfo }
                              onLikedMemberPagination={ onLikedMemberPagination }
                              likesInfo={ likesInfo }
                              onUserTyping={ () => {
                                 onUserTyping() } }
                              typerText={ typerText }
                              onLikeMessage={ (messageId, isLiked) => {
                                 const data = { messageId, isLiked }
                                 onLikeMessage(data)
                              } }
                              onDeleteMessag={ (id) => {
                                 const data = { messageId: id }
                                 onDeleteMessag(data)
                              } }
                              sendMessage={ onSendMessage }
                              converstionInfo={ { content, ...activeMessageTab.conversation, user_uuid: activeMessageTab?.type === 'private' ? adminUuid : null, chat_room_id: activeMessageTab.id } }
                              mutedInfo={ mutedInfo }
                              emptyState={ emptyState }
                              onReadMessage={ () => onReadMessage() }
                              isMobile={ isMobile }
                              lastSeen={ lastSeen }
                              diff={ 73 }
                              setMutedMemberInfo={ setMutedMemberInfo }
                              isConnected={ isSocketConnected }
                              closeChatPopup={ closeChatPopup }
                              memberCanOnlyRead={ isNotActive }
                              needToJoin={ needToJoin }
                              onStream={ onStream }
                              goToContentMessage={ goToContentMessage }
                              goToJoin={ goToJoin }
                              purchaseMessageId={ purchaseMessageId }
                              paymentButtonLoading={ paymentButtonLoading }
                              downloadFile={ downloadFile }
                              adminUuid={ adminUuid }
                              onSendVoiceMessage={ onSendVoiceMessage }
                              privateAttachmentSettings={ privateAttachmentSettings }
                              paymentButtonResourceId={ paymentButtonResourceId }
                              onUpdateRecordStatus={ onUpdateRecordStatus }
                              onSaveUploadPhotos={ onSaveUploadPhotos }
                              handleUploadImage={ uploadImage }
                              isDemoMode={ siteInfo?.is_demo_mode }
                              goTo={ goTo }
                              mainMessageId={ mainMessageId }
                              siteInfo={ siteInfo }
                              screenWidth={ screenWidth }
                              onClickNotificationMessageButton={ onClickNotificationMessageButton }
                              currentLiveStream={ currentLiveStream }
                              initLivestreamData={ initLivestreamData }
                           />
                        )
                     }
                  </>
               )
            }
         </div>
      </div>
   )
};
DesktopChat.defaultProps = {
};
DesktopChat.propTypes = {
   converstions: PropTypes.array,
   onCloseChat: PropTypes.func,
   hasAccess: PropTypes.bool,
   onClickConversation: PropTypes.func,
   onScroll: PropTypes.func,
   authUser: PropTypes.object,
   fetchNextMessages: PropTypes.bool,
   isFetchingMessage: PropTypes.bool,
   likesInfo: PropTypes.object,
   onFetchLikesInfo: PropTypes.func,
   onLikedMemberPagination: PropTypes.func,
   onClickLockedButton: PropTypes.func,
   planPrice: PropTypes.any,
   onUserTyping: PropTypes.func,
   typerText: PropTypes.string,
   onLikeMessage: PropTypes.func,
   // privateMessages: PropTypes.object,
   data: PropTypes.any,
   activeMessageTab: PropTypes.object,
   onDeleteMessag: PropTypes.func,
   onSendMessage: PropTypes.func,
   mutedInfo: PropTypes.object,
   emptyState: PropTypes.object,
   onReadMessage: PropTypes.func,
   isMobile: PropTypes.bool,
   lastSeen: PropTypes.string,
   setMutedMemberInfo: PropTypes.func,
   isNotActive: PropTypes.bool,
   notActiveText: PropTypes.string,
   onClickNotActive: PropTypes.func,
   isSocketConnected: PropTypes.bool,
   loaderText: PropTypes.string,
   nonAccessAvatar: PropTypes.string,
   onClickTip: PropTypes.func,
   isOpen: PropTypes.bool,
   closeChatPopup: PropTypes.func,
   showOnlyViews: PropTypes.bool,
   isNewVersion: PropTypes.bool,
   onStream: PropTypes.func,
   goToContentMessage: PropTypes.func,
   needToJoin: PropTypes.bool,
   goToJoin: PropTypes.func,
   purchaseMessageId: PropTypes.number,
   paymentButtonLoading: PropTypes.bool,
   openLiveStreamConversation: PropTypes.func,
   streamConversation: PropTypes.object,
   userStatus: PropTypes.string,
   adminScreenName: PropTypes.string,
   isLiveStream: PropTypes.bool,
   downloadFile: PropTypes.func,
   adminUuid: PropTypes.string,
   onSendVoiceMessage: PropTypes.func,
   privateAttachmentSettings: PropTypes.object,
   paymentButtonResourceId: PropTypes.string,
   onUpdateRecordStatus: PropTypes.func,
   onSaveUploadPhotos: PropTypes.func,
   goTo: PropTypes.func,
   mainMessageId: PropTypes.any,
   screenWidth: PropTypes.number,
   onClickNotificationMessageButton: PropTypes.func,
   currentLiveStream: PropTypes.object,
   initLivestreamData: PropTypes.object,
};

export default DesktopChat;
